import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { inputState, inquiryState, productsState, stepState } from '../states/messageState'
import { useInViewFooter } from './useInViewFooter'
import { useSendMessage } from './useSendMessage'

export const useCheckEmail = () => {
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const { handleInViewFooter } = useInViewFooter()

  const products = useRecoilValue(productsState)
  const setInput = useSetRecoilState(inputState)
  const setCurrentStep = useSetRecoilState(stepState)

  const checkEmail = async () => {
    setInput('')
    await handleAddSenderParent(
      'bot',
      `こちらからご登録されているメールアドレスにご連絡致します。\nサポートメールが一部キャリアメールに届かない恐れがありますので「@helloproteger.com」と「@kiva.co.jp」のメールを受け取れる様に設定をお願いします。`
    )
    const hasEmail = products.some(({ hasEmail }) => hasEmail)
    //メールアドレスが登録されていない場合、登録させるSTEPに進む
    const message = hasEmail ? '登録されているメールアドレスを変更しますか？' : 'メールアドレスを登録して下さい'
    const step = hasEmail ? 'chooseChangeEmail' : 'inputUpdateEmail'

    await handleAddMessage('bot', message)
    handleInViewFooter()
    setCurrentStep(step)
  }

  return { checkEmail }
}
